import { COUNTRY } from '../const/constants'
import { useAppContext } from '../context/AppContext'

const useValidate = () => {
  const { settings }: any = useAppContext()
  const validate = (state: any, inputName: string, extraValidation?: boolean): any => {
    let error = ''

    // Regular expressions
    const regExNombreYApellido = /^[a-zA-ZÀ-ÿ']+(?:\s[a-zA-ZÀ-ÿ']+)*$/
    const regExNumberOnly = /^\d+$/
    const regExNumberFloor = /^\d+$/
    const regExAlphaNumeric = /^[0-9a-zA-Z\u00f1\u00d1\s]+$/
    const regExEmail = /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/

    if (
      (inputName === 'nombre' ||
        inputName === 'names' ||
        inputName === 'apellido' ||
        inputName === 'firstName' ||
        inputName === 'lastName') &&
      !regExNombreYApellido.test(state)
    )
      error = 'Sólo podés ingresar letras.'

    if (inputName === 'documento' || inputName === 'documentNumber') {
      if (settings.country !== COUNTRY.PY && !regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
      else if (
        state.length > settings.validation.documentMaxLength ||
        state.length < settings.validation.documentMinLength
      )
        error = `Debés ingresar entre ${settings.validation.documentMinLength} y ${settings.validation.documentMaxLength} caracteres.`
    }

    if (inputName === 'passport') {
      if (!regExAlphaNumeric.test(state)) error = 'Sólo podés ingresar letras y números.'
      else if (state.length > 15 || state.length < 5) error = `Debés ingresar entre 5 y 15 caracteres.`
    }

    if (inputName === 'telefono' || inputName === 'lineNumber' || inputName === 'phoneNumber') {
      if (state[0] === '0') error = 'Ingresá el número sin el 0 al inicio.'
      else if (!regExNumberOnly.test(state)) error = 'Verificá que el número ingresado esté correcto.'
      else if (state.length !== settings.validation.lineNumberLength)
        error = `Debés ingresar ${settings.validation.lineNumberLength} caracteres.`
    }

    if (inputName === 'negocio' && state === '') error = 'Seleccioná negocio/producto.'

    if (inputName === 'addressNumber') {
      if (!regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
    }

    if (inputName === 'addressFloor') {
      if (!regExNumberFloor.test(state)) error = 'Sólo podés ingresar números.'
    }

    if (inputName === 'addressFlat') {
      if (!regExAlphaNumeric.test(state)) error = 'Sólo podés ingresar letras y números.'
    }

    if (inputName === 'emailOptional') {
      if (state && !regExEmail.test(state)) error = 'Formato incorrecto.'
    }

    if (inputName === 'cardNumber' && !regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
    else if (inputName === 'cardNumber' && state.length !== settings.validation.simNumberLength)
      error = `Debés ingresar ${settings.validation.simNumberLength} caracteres.`

    if (inputName === 'chipNumber') {
      if (!regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
      else if (state.length !== settings.validation.nimNumberLength)
        error = `Debés ingresar ${settings.validation.nimNumberLength} caracteres.`
    }

    if (inputName === 'username') {
      if (state[0] !== '0' && !extraValidation) error = 'Ingresá el número con el 0 al inicio.'
      else if (!regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
      else if (state.length < 3) error = `Debés ingresar más de 3 caracteres.`
    }

    if (inputName === 'password') {
      if (state.length !== 4) error = `Debés ingresar 4 caracteres.`
    }

    if (inputName === 'posNumberProcedure') {
      if (!regExNumberOnly.test(state)) error = 'Sólo podés ingresar números.'
      else if (state.length < settings.validation.posNumberMinLength)
        error = `Debés ingresar más de ${settings.validation.posNumberMinLength} caracteres.`
    }

    if (!state.length) error = 'Este campo es obligatorio.'

    return error
  }

  return {
    validate
  }
}

export default useValidate
